/**
 * Code generated by "npm run build-assets"
 * Figma URL: https://nda.ya.ru/t/Llix30Rx6QshVc
 */

import {type ImageAssetMeta, SrcSet} from '@yandex-delivery/assets'

import img1x from './go-app-logo@1x.png'
import img2x from './go-app-logo@2x.png'
import img3x from './go-app-logo@3x.png'

export const goAppLogo: ImageAssetMeta = {
  width: 63,
  height: 68,
  srcSet: new SrcSet(img1x, img2x, img3x),
}
